module.exports = __webpack_public_path__ + "static/media/cancel_icon.5a754e50.svg";